/** Angular component class names used as CB2 preview scenario blocType keys. */
export const SHOP_PRODUCT_LIST_BLOCK_COMPONENT = 'ShopProductListBlockComponent';
export const SHOP_HERO_IMAGE_BLOCK_COMPONENT = 'ShopHeroImageBlockComponent';
export const SHOP_AROUND_LIST_BODY_BLOCK_COMPONENT = 'ShopAroundListBodyBlockComponent';
export const SHOPS_MAP_BLOCK_COMPONENT = 'ShopsMapBlockComponent';
export const CART_MERCHANT_AMOUNT_BLOCK_COMPONENT = 'CartMerchantAmountBlockComponent';
export const CART_TIP_PICKER_BLOCK_COMPONENT = 'CartTipPickerBlockComponent';
export const CART_ITEM_LIST_BLOCK_COMPONENT = 'CartItemListBlockComponent';
export const CHECK_DETAILS_BLOCK_COMPONENT = 'CheckDetailsBlockComponent';
export const CHECKS_PAGE_BLOCK_COMPONENT = 'ChecksPageBlockComponent';
export const ORDERS_PAGE_BLOCK_COMPONENT = 'OrdersPageBlockComponent';
export const PAT_OVERVIEW_BLOCK_COMPONENT = 'PatOverviewBlockComponent';
export const CART_RECOMMENDATION_CARDS_BLOCK_COMPONENT = 'CartRecommendationCardsBlockComponent';
export const CART_SUGGESTION_CARDS_BLOCK_COMPONENT = 'CartSuggestionCardsBlockComponent';
export const SUGGESTION_CARDS_BLOCK_COMPONENT = 'SuggestionCardsBlockComponent';
export const KIOSK_SHOP_CATEGORY_LIST_BLOCK_COMPONENT = 'KioskShopCategoryListBlockComponent';
export const KIOSK_CATEGORY_PAGE_COMPONENT = 'KioskCategoryPageComponent';
export const KIOSK_CART_PRODUCTS_LIST_BLOCK_COMPONENT = 'KioskCartProductsListBlockComponent';
export const KIOSK_FOOTER_CART_BLOCK_COMPONENT = 'KioskFooterCartBlockComponent';
export const KIOSK_ORDER_STATUS_BLOCK_COMPONENT = 'KioskOrderStatusBlockComponent';
export const ORDER_STATUS_BLOCK_COMPONENT = 'OrderStatusBlockComponent';
export const ORDER_DETAILS_BLOCK_COMPONENT = 'OrderDetailsBlockComponent';
export const ORDER_INVOICE_BLOCK_COMPONENT = 'OrderInvoiceBlockComponent';
export const PAYMENT_METHOD_PICKER_BLOCK_COMPONENT = 'PaymentMethodPickerBlockComponent';
export const KIOSK_PAYMENT_METHOD_PICKER_BLOCK_COMPONENT = 'KioskPaymentMethodPickerBlockComponent';
export const KIOSK_PRODUCT_ADD_PAGE_COMPONENT = 'KioskProductAddPageComponent';
export const KIOSK_SUGGESTIONS_MODAL_BLOCK_COMPONENT = 'KioskSuggestionsModalBlockComponent';
export const KIOSK_CART_RECOMMENDATION_CARDS_BLOCK_COMPONENT =
  'KioskCartRecommendationCardsBlockComponent';
export const CART_VOUCHER_BLOCK_COMPONENT = 'CartVoucherBlockComponent';
export const COMO_JOIN_LOYALTY_BLOCK_COMPONENT = 'ComoJoinLoyaltyBlockComponent';
export const COMO_ASSET_LIST_BLOCK_COMPONENT = 'ComoAssetListBlockComponent';
export const COMO_CREDIT_BALANCE_CARD_BLOCK_COMPONENT = 'ComoCreditBalanceCardBlockComponent';
export const COMO_HOME_MOSAIC_BLOCK_COMPONENT = 'ComoHomeMosaicBlockComponent';
export const COMO_PUNCH_CARDS_BLOCK_COMPONENT = 'ComoPunchCardsBlockComponent';
export const ZEROSIX_ASSET_LIST_BLOCK_COMPONENT = 'ZerosixAssetListBlockComponent';
export const PONGO_ASSET_LIST_BLOCK_COMPONENT = 'PongoAssetListBlockComponent';
export const AUTHENTICATION_MODAL_COMPONENT = 'AuthenticationModalComponent';
export const CROSS_SELLING_MODAL_COMPONENT = 'CrossSellingModalComponent';
export const UPSELLING_MODAL_COMPONENT = 'UpsellingModalComponent';
export const PRODUCT_ADD_MODAL_COMPONENT = 'ProductAddModalComponent';
export const USER_FEEDBACK_BLOCK_COMPONENT = 'UserFeedbackBlockComponent';
